import Html from './html'

export default Html



// WEBPACK FOOTER //
// ./src/components/fields/html/index.js